import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './button.module.css'

type ButtonAnchorHTMLAttributes = React.ButtonHTMLAttributes<
  HTMLButtonElement
> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

interface IProps extends ButtonAnchorHTMLAttributes {
  large?: boolean
  primary?: boolean
  altPrimary?: boolean
  active?: boolean
  fixedWidth?: boolean
}

const Button = (props: IProps) => {
  const {
    className,
    children,
    large,
    primary,
    altPrimary,
    active,
    ...nextProps
  } = props

  const Tag: any = nextProps.href ? 'a' : 'button'
  const nextClassName = classnames(styles.button, className, {
    [styles.large]: large,
    [styles.primary]: primary,
    [styles.altPrimary]: altPrimary,
    [styles.active]: active
  })

  return (
    <Tag className={nextClassName} {...nextProps}>
      {children}
    </Tag>
  )
}

export default Button
